import React from 'react';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';

interface GuideCard {
  badge: string;
  title: string;
  description: string;
  videoSrc: string;
}

interface HelpSupportProductGuideProps {
  items: GuideCard[];
}

export const HelpSupportProductGuide: React.FC<HelpSupportProductGuideProps> = ({ items }) => {
  return (
    <Grid container spacing={2.5}>
      {items.map((item) => (
        <Grid key={item.title} size={{ xs: 12, md: 6, lg: 4 }}>
          <Card
            elevation={0}
            sx={{
              borderRadius: '12px',
              border: '1px solid #ebebf1',
              boxShadow: '0 8px 18px rgba(17,24,39,0.06)',
              overflow: 'hidden',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                height: 210,
                bgcolor: '#111827',
                overflow: 'hidden',
              }}
            >
              <Box
                component="video"
                src={item.videoSrc}
                controls
                preload="metadata"
                playsInline
                sx={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  bgcolor: '#111827',
                }}
              />
              <Typography
                sx={{
                  position: 'absolute',
                  top: 16,
                  left: 16,
                  display: 'inline-flex',
                  borderRadius: '999px',
                  px: 1.5,
                  py: 0.5,
                  fontSize: 12,
                  fontWeight: 500,
                  color: '#1d2b2d',
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  pointerEvents: 'none',
                  boxShadow: '0 4px 12px rgba(15,23,42,0.16)',
                }}
              >
                {item.badge}
              </Typography>
            </Box>

            <CardContent sx={{ p: 2.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography sx={{ fontSize: 20, lineHeight: 1.3, fontWeight: 600, color: '#1d2b2d' }}>{item.title}</Typography>
              <Typography sx={{ mt: 1, mb: 2, fontSize: 14, lineHeight: '24px', color: '#717182' }}>{item.description}</Typography>
              <Button
                component="a"
                href={item.videoSrc}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                startIcon={<PlayArrowRoundedIcon />}
                sx={{
                  mt: 'auto',
                  alignSelf: 'flex-start',
                  height: 40,
                  px: 2,
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontSize: 14,
                  fontWeight: 500,
                  backgroundColor: '#20aedc',
                  boxShadow: 'none',
                  '&:hover': { backgroundColor: '#1a9cc7', boxShadow: 'none' },
                }}
              >
                Watch Demo
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
